/* eslint-disable no-shadow */
import { appendParams } from '@utils/func'
import { API } from '@utils/axios'
import { IAPI } from 'AppTypes'

export class AnimeSubmissionAPI implements IAPI {
  prefix = '/SubmissionManagement'

  fetchList (params: TAnimeSubscriptionAPI.Params.FetchList) {
    const url = appendParams(`${this.prefix}/list`, params)
    return API.get<TAnimeSubscription.State['animeSubmissionsListData']>(url)
  }

  fetchVideoList (params: TAnimeSubscriptionAPI.Params.FetchList) {
    const url = appendParams('VideoPremiumEditOrder/GetPagedPremiumVideoOrders', params)
    return API.get<TAnimeSubscription.State['videoSubmissionsListData']>(url)
  }

  fetchSingle (id: string) {
    return API.get<TAnimeSubscription.State['animeSubscriptionDetail']>(`VideoPremiumEditOrder/GetById/?Id=${id}`)
  }

  fetchSingleHistory (id: string) {
    return API.get<TAnimeSubscription.State['historyRequest']>(`VideoPremiumEditOrder/OrderHistory/?OrderId=${id}`)
  }

  fetchAprroverList () {
    return API.get<TAnimeSubscription.State['approvers']['data']>('AdminUser/GetAdmins')
  }

  saveTemporary (data: TAnimeSubscriptionAPI.Body.SaveAnimeSubmission) {
    return API.put('VideoPremiumEditOrder/SaveAsDraft', data)
  }

  submitForApproval (data: TAnimeSubscriptionAPI.Body.SubmitForApprovalAnime) {
    return API.put('VideoPremiumEditOrder/Submit', data)
  }

  approve (data: TAnimeSubscriptionAPI.Body.ApproveAnime) {
    return API.patch('VideoPremiumEditOrder/Approve', data)
  }

  reject (data: TAnimeSubscriptionAPI.Body.RejectAnime) {
    return API.patch('VideoPremiumEditOrder/reject', data)
  }

  cancel (data: any) {
    return API.patch('VideoPremiumEditOrder/Cancel', data)
  }

  delete (data: any) {
    return API.patch('VideoPremiumEditOrder/Delete', data)
  }

  downloadVideo (videoId: string, orderId: string) {
    return API.get(`VideoPremiumEditOrder/DownloadVideo?videoId=${videoId}&orderId=${orderId}`)
  }

  getUrlDownloadListVideoPremium (params: TAnimeSubscriptionAPI.Params.FetchList) {
    return appendParams('VideoPremiumEditOrder/downloadExcel', params)
  }

  createVideoPremium (data: any) {
    return API.post('VideoPremiumEditOrder/Create', data)
  }

  async downloadListVideoPremium (params: TChargeManagementAPI.Params.DownLoadByLiver) {
    const url = this.getUrlDownloadListVideoPremium(params)
    const response = await API.get(url, { responseType: 'blob' })
    return response.data
  }
}

export const animeSubmissionAPI = new AnimeSubmissionAPI()
